<template>
    <div>
        Detail
    </div>
</template>
<script>
    export default {
        name: 'PrepareDocDetail',
        data() {
            return {

            }
        }
    }
</script>